export default "__VITE_ASSET__CiTm1O7v__"